<template>
  <div class="prodetail">
    <div class="head">
      <div class="my-swipe">
        <img :src="datas.pic" v-if="datas.pic" />
      </div>
      <div class="p-info">
        <div class="price">
          <p>{{ $setInfoDecimal(datas.goods_price) }} </p>
          <p>月销{{ datas.goods_sale }}件</p>
        </div>
        <div class="pro-name">{{ datas.goods_name }}</div>
      </div>
    </div>

    <div></div>

    <div class="area"></div>
    <div class="detail-img" v-html="datas.detail" ref="detail">
      <!-- <img :src="require('../../assets/test/detail.png')" /> -->
    </div>

    <van-goods-action>
      <!-- <van-goods-action-icon :icon="require('../../assets/icon/service2.png')" text="客服" @click="showService" /> -->
      <van-goods-action-icon :icon="require('../../assets/icon/car.png')" text="购物车" to="/car" />
      <van-goods-action-button color="#FFC44E" type="warning" text="加入购物车" @click="addcar" />
      <van-goods-action-button color="#FF6161" type="danger" text="立即购买" @click="buyNow" />
    </van-goods-action>
  </div>
</template>
<script>
  import { Swipe, SwipeItem, Popup, Stepper, GoodsAction, GoodsActionIcon, GoodsActionButton, Dialog } from "vant";

  import paymentHandle from '@/utils/paymentHandle'
  import { getInfo } from '@/api/goods'
  import { addcar } from '@/api/car'
  export default {
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Popup.name]: Popup,
      [Stepper.name]: Stepper,
      [GoodsAction.name]: GoodsAction,
      [GoodsActionIcon.name]: GoodsActionIcon,
      [GoodsActionButton.name]: GoodsActionButton
    },
    data() {
      return {
        type: 'size',
        datas: {},
        selectedSizeGroup: []
      };
    },
    methods: {
      confirm() {
        this.show = false
      },
      // 点击添加购物车
      async addcar() {

        const { datas, $toast, $router } = this
        if (datas.status === 0) {
          $toast('商品已下架')
          $router.go(-1)
          return
        }
        const result = await addcar({
          goods_sn: datas.goods_sn,
          num: 1
        })
        $toast(result.data.data.message)
      },
      // 点击现在购买
      buyNow() {
        const { datas, $toast, $router } = this
        if (datas.status === 0) {
          $toast('商品已下架')
          $router.go(-1)
          return
        }
        paymentHandle.setPayment({
          [paymentHandle.api.payType]: paymentHandle.type.buyNow,
          [paymentHandle.api.payId]: this.datas.goods_sn
        })
        $router.push('/payment')
      },
      // 获取商品信息
      async getInfo() {
        const { $router, $route } = this
        const goods_sn = $route.query.pid
        const result = await getInfo({
          goods_sn
        })
        if (result.data.data.goodsInfo.status === 0) {
          Dialog.alert({
            title: '商品已下架',
          }).then(() => {
            $router.go(-1)
          });
        }
        this.datas = result.data.data.goodsInfo
      },
      showService() {
        Dialog.alert({
          title: '客服电话',
          message: '4000778183',
        }).then(() => {
          // on close
        });

      },
      resetDetail() {
        this.$nextTick(() => {
          let ssd = document.querySelector(".ssd-module-wrap");
          if (ssd) {
            setTimeout(() => {
              if (ssd.offsetWidth > document.body.offsetWidth) {
                ssd.style.width = document.body.clientWidth
                ssd.style.transform = `scale(${document.body.clientWidth / ssd.offsetWidth
                  },0.5)`;
                ssd.style.transformOrigin = "0 0";
                this.$refs.detail.style.height =
                  ssd.offsetHeight /
                  Math.ceil(ssd.offsetWidth / document.body.clientWidth) +
                  "px";
              }
            }, 500);
          }

        });
      },
    },
    created() {
      this.getInfo()
    },
    updated() {
      this.resetDetail();
    },
  };
</script>
<style lang="scss" scoped>
.my-swipe {
  height: 6.8rem;

  img {
    height: 100%;
  }
}

.p-info {
  background: #fff;
}

.prodetail {
  font-size: 0.32rem;

  .price {
    display: flex;
    justify-content: space-between;
    padding: 0.2rem;
    color: #ec0000;

    p {
      margin: 0;
    }

    :first-child {
      font-size: 0.43rem;
    }

    :last-child {
      font-size: 0.24rem;
    }
  }

  .pro-name {
    padding: 0 0.2rem;
  }

  .select-size {
    padding-bottom: 1rem;

    .s-upper {
      @include flexBox('');
      width: 5rem;
      margin: 0.5rem;

      .s-img {
        width: 2.26rem;
        height: 2.26rem;

        img {
          width: 100%;
          height: 100%;
          border: 1px solid#707070;
          border-radius: 10px;
        }
      }

      .s-selected {
        margin-left: 0.3rem;
        height: 2.26rem;

        p {
          margin: 0;
        }

        ul {
          li {
            width: 1.48rem;
            padding: 0.05rem 0.08rem;
            color: #ff3333;
            font-size: 0.24rem;
            border: 1px solid #ff3333;
            margin-top: 0.1rem;
            border-radius: 30px;
            text-align: center;
          }
        }
      }
    }

    .size-pro {
      padding: 0.2rem;

      .s-head {
        font-weight: 800;
      }

      .s-list {
        border-bottom: 1px solid #e9e9e9;

        ul {
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          li {
            width: 1.14rem;
            text-align: center;
            margin: 0.15rem 0.2rem;

            p {
              font-size: 0.24rem;
              margin: 0;
            }

            img {
              width: 100%;
              height: 1.14rem;
              border-radius: 10px;
              border: 1px solid #000000;
            }
          }
        }
      }
    }

    .count {
      @include flexBox(space-between);
      padding: 0.2rem;
    }

    .c-btn {
      margin-top: 0.1rem;

      button {
        width: 4.72rem;
        @include btn(#ff3333, 0.89rem);
      }
    }
  }

  .selected {
    img {
      border: 1px solid #ff3333 !important;
    }

    color: #ff3333;
  }

  .is-sale {
    padding: 0.2rem;
    font-size: 0.32rem;
    color: #ff3333;
  }

  .size {
    margin: auto;
    margin-top: 0.2rem;
    width: 7.15rem;
    padding: 0.1rem 0;
    border-bottom: 1px solid #707070;

    button {
      background: none;
      border: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 0.15rem 0.1rem;

      i {
        background: url('../../assets/icon/right.png') no-repeat 50%;
        display: block;
        width: 0.3rem;
        height: 0.3rem;
        background-size: 0.2rem;
      }
    }

    .select-group {
      width: 5rem;

      ul {
        display: flex;
        align-items: center;

        li {
          padding: 0.05rem 0.07rem;
          border-radius: 30px;
          margin-left: 0.1rem;
          border: 1px solid #707070;
          font-size: 0.24rem;
        }
      }
    }
  }

  .detail-img {
    margin-top: 0.8rem;
  }
}
</style>